import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Suppliers from './Suppliers';
import PurchaseOrderPage from '../../pages/purchase/PurchaseOrderPage';
import ViewPurchaseOrdersPage from '../../pages/purchase/ViewPurchaseOrdersPage';
import PurchaseReturnPage from '../../pages/purchase/PurchaseReturnPage';
import ViewPurchaseReturnsPage from '../../pages/purchase/ViewPurchaseReturnsPage';

const Purchases = () => {
  return (
    <Routes>
      <Route path="suppliers" element={<Navigate to="/people/suppliers" replace />} />
      <Route path="orders" element={<PurchaseOrderPage />} />
      <Route path="view-orders" element={<ViewPurchaseOrdersPage />} />
      <Route path="returns" element={<PurchaseReturnPage />} />
      <Route path="view-returns" element={<ViewPurchaseReturnsPage />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

export default Purchases; 